export class InverterSetupMPPTracker {
    stringCount: number;
    panelCount: number;


    constructor(stringCount: number, panelCount: number) {
        this.stringCount = stringCount;
        this.panelCount = panelCount;
    }

}
